import { MinusOutlined, PlusOutlined, EnterOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react'; // Added missing import for React

function BillingTable(props) {
  const intl = useIntl();
  const { showExpandButton = true } = props;
  const processTableData = data => {
    return data.map(day => {
      const mainRow = {
        key: day.date,
        date: day.date,
        transactionType: '-',
        totalQuantity: day.total_count,
        totalValue: day.total_amount,
        children: [],
        isParent: true,
      };

      const transactionTypes = [
        {
          key: `${day.date}-onboarding`,
          date: day.date,
          transactionType: 'Onboarding',
          totalQuantity: day.transactions?.onboarding?.count || 0,
          totalValue: day.transactions?.onboarding?.amount || 0,
          isParent: false,
        },
        {
          key: `${day.date}-verification`,
          date: day.date,
          transactionType: 'Verification',
          totalQuantity: day.transactions?.verification?.count || 0,
          totalValue: day.transactions?.verification?.amount || 0,
          isParent: false,
        },
        {
          key: `${day.date}-id-capture`,
          date: day.date,
          transactionType: 'ID Capture',
          totalQuantity: day.transactions?.id_capture?.count || 0,
          totalValue: day.transactions?.id_capture?.amount || 0,
          isParent: false,
        },
        {
          key: `${day.date}-rest-api`,
          date: day.date,
          transactionType: 'REST API',
          totalQuantity: day.transactions?.rest_api?.count || 0,
          totalValue: day.transactions?.rest_api?.amount || 0,
          isParent: false,
        },
      ];

      const transactionsWithValue = transactionTypes.filter(
        transaction =>
          transaction.totalValue > 0 || transaction.totalQuantity > 0,
      );

      if (transactionsWithValue.length === 1) {
        mainRow.transactionType = transactionsWithValue[0].transactionType;
        mainRow.children = [];
      } else if (transactionsWithValue.length > 1) {
        mainRow.transactionType = intl.formatMessage({
          id: 'page.billing.table.multiple_types',
        });
        mainRow.children = transactionsWithValue;
      }

      return mainRow;
    });
  };

  const processedData = processTableData(props.data);

  const formatCurrency = value => {
    return new Intl.NumberFormat(props.locale || 'en-US', {
      style: 'currency',
      currency: props.currency || 'USD',
    }).format(value || 0);
  };

  // Função para aplicar classe CSS nas linhas filhas
  const getRowClassName = (record, index) => {
    if (!record.isParent) {
      return 'child-row-hover';
    }
    return '';
  };

  const columns = [
    ...(showExpandButton
      ? [
          {
            title: '',
            dataIndex: 'expand',
            width: 50,
            render: _ => null,
          },
        ]
      : []),
    {
      title: <FormattedMessage id="page.billing.table.header.date" />,
      dataIndex: 'date',
      render: (_, record) => {
        if (!record.isParent) {
          return '';
        }
        return dayjs(record.date).format('DD/MM/YYYY');
      },
    },
    {
      title: (
        <FormattedMessage id="page.billing.table.header.transaction_type" />
      ),
      dataIndex: 'transactionType',
    },
    {
      title: <FormattedMessage id="page.billing.table.header.total_quantity" />,
      dataIndex: 'totalQuantity',
      render: value => {
        return value || 0;
      },
    },
    {
      title: <FormattedMessage id="page.billing.table.header.total_amount" />,
      dataIndex: 'totalValue',
      render: value => {
        return formatCurrency(value || 0);
      },
    },
  ];

  return (
    <div className="grid gap-y-5">
      <Table
        rowKey="key"
        pagination={false}
        scroll={{ y: 390 }}
        dataSource={processedData}
        columns={columns}
        rowClassName={getRowClassName}
        expandable={{
          defaultExpandAllRows: false,
          indentSize: 20,
          rowExpandable: record =>
            record.isParent && record.children && record.children.length > 0,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (!showExpandButton) {
              return null;
            }
            if (!record.children || record.children.length === 0) {
              return null;
            }
            return (
              <button
                type="button"
                onClick={e => onExpand(record, e)}
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px',
                }}
              >
                {expanded ? <MinusOutlined /> : <PlusOutlined />}
              </button>
            );
          },
        }}
      />
    </div>
  );
}

export default BillingTable;
